import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import { format } from "date-fns";

import html2pdf from "html2pdf.js";
import dayjs from "dayjs";
import commonLabels from "../../../common/labels/common_en.json";
import ApprovalVersionMismatchEntity from "../../components/examReport/ApprovalVersionMismatchEntity";
import TablePagination from "../../../common/components/TablePagination";
import label from "../../labels/postExaminationProcessObjective_en.json";
import {
  getExamslistByAdvertisementId,
  getAdvertisementsList,
  getSubjectlistByExamId,
  getVersionMismatchList,
  saveVersionMismatch,
  getDownloadVersionMismatch,
  getAllUnApproveVersionMismatchListPagination,
  objetiveStatusLockUnlock,
  getInvigilatorVersionMismatchList,
} from "../../actions/postExaminationProcessObjectiveActions";
import { set } from "lodash";
import {
  getYearList,
  getAdvertisementlistByYear,
} from "../../../common/actions/commonActions";
import { SET_VERSION_MISMATCH_LIST } from "../../../common/constants/ActionTypes";

const InvigilatorVersionMismatch = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedAdvertiseNo, setSelectedAdvertiseNo] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [requestData, setRequestData] = useState([]);
  const [stepName, setName] = useState("list");
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [isEditable, setIsEditable] = useState(false);
  let [isEdit, setIsEdit] = useState(false);
  let [isPrint, setIsPrint] = useState(false);
  const dispatch = useDispatch();
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  let [isAllICRBlank, setIsAllICRBlank] = useState(true);
  let [isAllOMRBlank, setIsAllOMRBlank] = useState(true);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [isSave, setIsSave] = useState(false);
  const date = new Date(); // Your date object here

  const formattedDate = format(date, 'MM/dd/yyyy');
  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];
  let rowPerPage = 10;
  const length = 50;

  useEffect(() => { }, [reloadItem]);

  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };
  useEffect(() => {
    if (stepName == "unapproved") {
      dispatch(
        getAllUnApproveVersionMismatchListPagination(
          listCurrentPage,
          rowPerPage
        )
      );
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getYearList());
    setRequestData([]);
    setReloadItem(!reloadItem);
    onCancelButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let {
    examList,
    advertisementList,
    subjectList,
    unapprovalVersionMismatchPageNoCounter,
    versionMismatchList,
    invigilatorVersionMismatchList,
    allUnapprovalVersionMismatchList,
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  useEffect(() => {
    if (
      invigilatorVersionMismatchList &&
      invigilatorVersionMismatchList.versionList &&
      invigilatorVersionMismatchList.versionList.length > 0
    ) {
      setIsEdit(true);
    }
  }, [invigilatorVersionMismatchList]);
  let tableCounter_unapproval = unapprovalVersionMismatchPageNoCounter + 1;

  useEffect(() => {
    setRequestData([]);
    let newRequestData = [];
    let newRequestData1 = [];
    let newRequestData2 = [];
    let newRequestData3 = [];
    invigilatorVersionMismatchList &&
      invigilatorVersionMismatchList.versionList &&
      invigilatorVersionMismatchList.versionList.length > 0 &&
      invigilatorVersionMismatchList.versionList.map((ele, index) => {
        if (
          ele.icr != "" &&
          ele.icr != 0 &&
          ele.icr != null &&
          ele.omr != "" &&
          ele.omr != 0 &&
          ele.omr != null
        ) {
          let newObj = {
            id: ele.id,
            rollNo: ele.rollNo,
            icr: ele.icr,
            omr: ele.omr,
            invigilatorIcr: ele.invigilatorIcr,
            invigilatorOmr: ele.invigilatorOmr,
          };
          newRequestData.push(newObj);
        } else if (
          ele.icr != "" &&
          ele.icr != 0 &&
          ele.icr != null &&
          (ele.omr == "" || ele.omr == 0 || ele.omr == null)
        ) {
          let newObj = {
            id: ele.id,
            rollNo: ele.rollNo,
            icr: ele.icr,
            omr: ele.omr,
            invigilatorIcr: ele.invigilatorIcr,
            invigilatorOmr: ele.invigilatorOmr,
          };
          newRequestData1.push(newObj);
        } else if (
          (ele.icr == "" || ele.icr == 0 || ele.icr == null) &&
          ele.omr != "" &&
          ele.omr != 0 &&
          ele.omr != null
        ) {
          let newObj = {
            id: ele.id,
            rollNo: ele.rollNo,
            icr: ele.icr,
            omr: ele.omr,
            invigilatorIcr: ele.invigilatorIcr,
            invigilatorOmr: ele.invigilatorOmr,
          };
          newRequestData2.push(newObj);
        } else {
          let newObj = {
            id: ele.id,
            rollNo: ele.rollNo,
            icr: ele.icr,
            omr: ele.omr,
            invigilatorIcr: ele.invigilatorIcr,
            invigilatorOmr: ele.invigilatorOmr,
          };
          newRequestData3.push(newObj);
        }
      });
    let mergedArray = [];
    mergedArray[0] = newRequestData;
    mergedArray[1] = newRequestData1;
    mergedArray[2] = newRequestData2;
    mergedArray[3] = newRequestData3;
    setRequestData(mergedArray);
    setReloadItem(!reloadItem);
  }, [invigilatorVersionMismatchList]);

  const onSubjectChange = (e) => {
    let selectedValue = e.target.value;
    setSelectedSubject(selectedValue);
    invigilatorVersionMismatchList = "";
    selectedValue &&
      dispatch(getInvigilatorVersionMismatchList(selectedExam, selectedValue));
    setIsEditable(false);
    setRequestData([]);
    setIsEdit(true);
    setReloadItem(!reloadItem);
    setIsPrint(false);
    setSaveButtonFlag(false);
    if (requestData && !(requestData.length > 0)) {
      setIsEdit(false);
    }
    // else if(requestData && (requestData.length > 0)){
    //   setIsEdit(true);
    // }
  };
  const onCancelButton = () => {
    setSelectedYear("");
    setSelectedAdvertiseNo("");
    setSelectedSubject("");
    setSelectedExam("");
    allYearList.length = 0;
    examList.length = 0;
    subjectList.length = 0;
    invigilatorVersionMismatchList = '';
    setRequestData([]);
    setSaveButtonFlag(true);
    setIsEditable(false);
    setIsPrint(false);
    setIsEdit(false);
    setReloadItem(!reloadItem);

  };

  // const onExamChange = (ele) => {
  //   let selectedValue = ele;
  //   setSelectedExam(selectedValue);
  //   subjectList.length = 0;
  //   invigilatorVersionMismatchList = '';
  //   selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
  //   setRequestData([]);
  //   setIsEdit(false);
  //   setReloadItem(!reloadItem);
  //   setIsPrint(false);
  //   setSaveButtonFlag(true);
  //   setIsEditable(false);
  // };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    subjectList.length = 0;
    invigilatorVersionMismatchList = "";
    selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
    setRequestData([]);
    setIsEdit(false);
    setReloadItem(!reloadItem);
    setIsPrint(false);
    setSaveButtonFlag(true);
    setIsEditable(false);
  };

  const printVersionMismatchPdf = () => {
    genPdf();
    //dispatch(getDownloadVersionMismatch());
  };

  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><div class="col-md-12 text-center text-uppercase"><h4>' +
      commonLabels.MPSC +
      "</h4><h5>" +
      invigilatorVersionMismatchList.examName +
      "</h5><h5>" +
      invigilatorVersionMismatchList.subjectName +
      "</h5><h5>" +
      commonLabels.VersionMismatchPdfTitle +
      "</h5></div></div>";

    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "versionMismatch.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");

          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, textX, textY);

          const ad = invigilatorVersionMismatchList.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save("versionMismatch.pdf");
      });
  };

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    setSelectedYear(selectedValue);
    selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
    if (allYearList) {
      allYearList.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }
    if (subjectList) {
      subjectList.length = 0;
    }
    dispatch({
      type: SET_VERSION_MISMATCH_LIST,
      payload: [],
    });
    setSaveButtonFlag(true);
    setIsEdit(false);
    setReloadItem(!reloadItem);
    setIsPrint(false);
  };

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertiseNo(selectedValue);
    setSelectedExam("");
    examList.length = 0;
    subjectList.length = 0;
    invigilatorVersionMismatchList = "";
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setRequestData([]);
    setReloadItem(!reloadItem);
    setIsEdit(false);
    setIsPrint(false);
  };

  return (
    <div>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group ">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, index) => (
                        <option>{element}</option>
                        // <option key={index} value={element.id}>
                        //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                        // </option>
                      ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-4">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-3">
                  <label className="float-left">
                    {label.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index + 1} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-3">
                  <label className="float-left">
                    {label.SelectSubject}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedSubject"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSubjectChange(e);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {subjectList &&
                      subjectList.length > 0 &&
                      subjectList
                        // .filter(
                        //   (element) =>
                        //     element.isDeleted === false &&
                        //     element.isActive === true
                        // )
                        .map((element, index) => (
                          <option key={index + 1} value={element.id}>
                            {element.name}({element.type?.toUpperCase()})
                          </option>
                        ))}
                  </select>
                  {_.get("selectedSubject.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-6">
                  <button
                    type="reset"
                    className="btn btn-secondary mr-2"
                    onClick={() => onCancelButton()}
                  >
                    {commonLabels.BUTTON_CANCEL}
                  </button>
                  {/* <button
                          type="button"
                          className="btn btn-primary mr-2"
                          onClick={()=>onEdit()}
                          disabled={!isEdit}
                        >
                          {commonLabels.BUTTON_EDIT}
                        </button> */}

                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary") && (
                      <button
                        type="button"
                        className="btn btn-primary mr-2"
                        disabled={
                          saveButtonFlag ||
                          isEditable ||
                          !invigilatorVersionMismatchList.versionList
                        }
                        onClick={() => printVersionMismatchPdf()}
                      >
                        {commonLabels.BUTTON_PRINT}
                      </button>
                    )}
                  {/* {(session.roleName == 'superadmin' || session.roleName == 'secretary') &&
                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            // disabled={saveButtonFlag}
                            disabled={(invigilatorVersionMismatchList.isStatusLocked!==null &&invigilatorVersionMismatchList.isStatusLocked!==true && invigilatorVersionMismatchList.isStatusLocked!==false) || saveButtonFlag}
                            onClick={() => {
                              handleLockUnlock(!invigilatorVersionMismatchList.isStatusLocked);
                            }}
                          >
                        
                            {!invigilatorVersionMismatchList.isStatusLocked && commonLabels.BUTTON_LOCK}
                            {invigilatorVersionMismatchList.isStatusLocked && commonLabels.BUTTON_UNLOCK}
                          </button>} */}


                </div>
              </div>
              {((invigilatorVersionMismatchList &&
                invigilatorVersionMismatchList.versionList != null)) && (
                  <div ref={pdfRef} id="versionMismatchData" >
                    {requestData && requestData.length > 0 && requestData.map((version, ind) => (
                      <div key={ind}>
                        {(ind == 0 && version.length > 0) ? <h5 class="bgColor-black text-white text-center">{commonLabels.VersionMismatchPdfSubTitle}</h5> : ""}
                        {(ind == 1 && version.length > 0) ? <h5 class="bgColor-black text-white text-center">{commonLabels.VersionMismatchPdfSubTitle1}</h5> : ""}
                        {(ind == 2 && version.length > 0) ? <h5 class="bgColor-black text-white text-center">{commonLabels.VersionMismatchPdfSubTitle2}</h5> : ""}
                        {(ind == 3 && version.length > 0) ? <h5 class="bgColor-black text-white text-center">{commonLabels.VersionMismatchPdfSubTitle3}</h5> : ""}
                        {version && version.length > 0 &&
                          <div className="row">
                            <div className="col-md-12">
                              <table className="table w-100">
                                <tbody>
                                  <tr>
                                    <td className="w-50">
                                      {version && version.length > 0 &&
                                        <table className="table table-bordered">
                                          <thead className="thead-light">

                                            <tr  >
                                              <th scope="col " rowSpan={2}>{commonLabels.SrNo}</th>
                                              <th scope="col " rowSpan={2}>{label.RollNo}</th>
                                              <th scope="col text-center" colSpan={2} >{label.CandidateLabel}</th>
                                              {/* <th scope="col " rowSpan={2}>{commonLabels.SrNo}</th> */}
                                              {/* <th scope="col " rowSpan={2}>{label.RollNo}</th> */}
                                              <th scope="col text-center" colSpan={2} >{label.InvigilatorLabel}</th>
                                            </tr>
                                            <tr>
                                              <th scope="col ">{label.VersionICR}</th>
                                              <th scope="col ">{label.VersionOMR}</th>
                                              <th scope="col ">{label.VersionICR}</th>
                                              <th scope="col ">{label.VersionOMR}</th>
                                            </tr>

                                            {/* <tr  >
                                                    <th scope="col " rowSpan={2}>{commonLabels.SrNo}</th>
                                                    <th scope="col " rowSpan={2}>{label.RollNo}</th>
                                                    <th scope="col text-center" colSpan={2} >{label.CandidateLabel}</th>
                                                  </tr>
                                                  <tr>
                                                    <th scope="col ">{label.VersionICR}</th>
                                                    <th scope="col ">{label.VersionOMR}</th>
                                                  </tr> */}
                                          </thead>

                                          <tbody className="table-font-12">
                                            {version && version.length > 0 &&
                                              version.map((ele, index) => {
                                                // if (index % 2 == 0) { 

                                                return (
                                                  <tr key={index}>
                                                    <td className="text-center">{index + 1}</td>
                                                    <td className="text-center">{ele.rollNo}</td>
                                                    <td>{ele.icr}</td>
                                                    <td>{ele.omr}</td>
                                                    <td>{ele.invigilatorIcr}</td>
                                                    <td>{ele.invigilatorOmr}</td>

                                                    {/* <td>
                                                              {isEditable == true ?
                                                                <input
                                                                  type="text"
                                                                  pattern="^(0|AB|BC|AC|AD|BD|CD)$"
                                                                  className="form-control"
                                                                  name="versionICR"
                                                                  defaultValue={ele.icr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionICR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                  onKeyPress={(e) => {
                                                                    const input = e.key.toUpperCase();
                                                                    const allowedChars = ['A', 'B', 'C', 'D', '0'];

                                                                    if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 2) {
                                                                      e.preventDefault();
                                                                    }
                                                                  }}
                                                                />
                                                                :
                                                                <input
                                                                  type="type"
                                                                  readOnly
                                                                  className="form-control"
                                                                  name="versionICR"
                                                                  defaultValue={ele.icr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionICR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                />
                                                              }
                                                            </td> */}
                                                    {/* <td>
                                                    {/* <td>
                                                              {isEditable == true ?
                                                                <input
                                                                  type="text"
                                                                  pattern="^(0|AB|BC|AC|AD|BD|CD)$"
                                                                  className="form-control"
                                                                  name="versionOMR"
                                                                  defaultValue={ele.omr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionOMR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                  onKeyPress={(e) => {
                                                                    const input = e.key.toUpperCase();
                                                                    const allowedChars = ['A', 'B', 'C', 'D', '0'];

                                                                    if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 2) {
                                                                      e.preventDefault();
                                                                    }
                                                                  }}
                                                                />
                                                                :
                                                                <input
                                                                  type="type"
                                                                  readOnly
                                                                  className="form-control"
                                                                  name="versionOMR"
                                                                  defaultValue={ele.omr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionOMR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                />
                                                              }

                                                            </td> */}
                                                  </tr>
                                                );
                                                // }

                                              })}
                                          </tbody>
                                        </table>
                                      }
                                      {/* </td>
                                          <td className="w-50"> */}
                                      {/* {version && version.length > 1 &&
                                              <table className="table table-bordered">
                                                <thead className="thead-light">

                                                  <tr  >
                                                    <th scope="col " rowSpan={2}>{commonLabels.SrNo}</th>
                                                    <th scope="col " rowSpan={2}>{label.RollNo}</th>
                                                    <th scope="col text-center" colSpan={2} >{label.CandidateLabel}</th>
                                                  </tr>
                                                  <tr>
                                                    <th scope="col ">{label.VersionICR}</th>
                                                    <th scope="col ">{label.VersionOMR}</th>
                                                  </tr>

                                                </thead>
                                                <tbody className="table-font-12">
                                                  {version && version.length > 1 &&
                                                    version.map((ele, index) => {
                                                      if (index % 2 != 0) {
                                                        return (
                                                          <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{ele.rollNo}</td>
                                                            <td>{ele.icr}</td>
                                                            <td>{ele.omr}</td> */}

                                      {/* <td>
                                                              {isEditable == true ?
                                                                <input
                                                                  type="text"
                                                                  pattern="^(0|AB|BC|AC|AD|BD|CD)$"
                                                                  className="form-control"
                                                                  name="versionICR"
                                                                  defaultValue={ele.icr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionICR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                  onKeyPress={(e) => {
                                                                    const input = e.key.toUpperCase();
                                                                    const allowedChars = ['A', 'B', 'C', 'D', '0'];

                                                                    if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 2) {
                                                                      e.preventDefault();
                                                                    }
                                                                  }}
                                                                />
                                                                :
                                                                <input
                                                                  type="type"
                                                                  readOnly
                                                                  className="form-control"
                                                                  name="versionICR"
                                                                  defaultValue={ele.icr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionICR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                />
                                                              }
                                                            </td>
                                                            <td>
                                                              {isEditable == true ?
                                                                <input
                                                                  type="text"
                                                                  pattern="^(0|AB|BC|AC|AD|BD|CD)$"
                                                                  className="form-control"
                                                                  name="versionOMR"
                                                                  defaultValue={ele.omr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionOMR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                  onKeyPress={(e) => {
                                                                    const input = e.key.toUpperCase();
                                                                    const allowedChars = ['A', 'B', 'C', 'D', '0'];

                                                                    if (!allowedChars.includes(input) || /[a-z]/.test(e.key) || e.target.value.length >= 2) {
                                                                      e.preventDefault();
                                                                    }
                                                                  }}
                                                                />
                                                                :
                                                                <input
                                                                  type="type"
                                                                  readOnly
                                                                  className="form-control"
                                                                  name="versionOMR"
                                                                  defaultValue={ele.omr}
                                                                  onChange={(e) => {
                                                                    onChangeVersionOMR(
                                                                      e.target.value,
                                                                      ele.rollNo
                                                                    );
                                                                  }}
                                                                />
                                                              }
                                                            </td> */}
                                      {/* </tr>
                                                        );
                                                      }

                                                    })}
                                                </tbody>
                                              </table> 
                                            }*/}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        }

                      </div>
                    ))}
                  </div>
                )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default InvigilatorVersionMismatch;
